import { FAVORITES_FEATURE_KEY, FavoritesState } from './favorites.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const favoritesState = createFeatureSelector<FavoritesState>(FAVORITES_FEATURE_KEY);

export const favoriteStops = createSelector(favoritesState, (state: FavoritesState) => state.favoriteStops);
export const favoriteStopsLoading = createSelector(
    favoritesState,
    (state: FavoritesState) => state.favoriteStopLoading
);
export const favoriteLocations = createSelector(favoritesState, (state: FavoritesState) => state.favoriteLocations);
export const favoriteTickets = createSelector(favoritesState, (state: FavoritesState) => state.favoriteTickets);
export const favoriteTicketsLoading = createSelector(
    favoritesState,
    (state: FavoritesState) => state.favoriteTicketsLoading
);
export const favoritePreference = createSelector(favoritesState, (state: FavoritesState) => state.favoritePreference);

export const favoriteSchedules = createSelector(favoritesState, (state: FavoritesState) => state.favoriteSchedules);
